import ReactDOM from "react-dom/client";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import { AliveScope } from "react-activation";
import { lazy, Suspense } from "react";

import "./assets/iconfont/iconfont.css";
import "./index.css";
import "./preflight.css";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";

const Home = lazy(() => import("@/page/home"));
const Tpls = lazy(() => import("@/page/tpls"));
const Editor = lazy(() => import("@/page/editor"));
const Bgs = lazy(() => import("@/page/bgs"));
const About = lazy(() => import("@/page/about"));
const Interpolation = lazy(() => import("@/page/interpolation"));
const Help = lazy(() => import("@/page/help"));
const NotFound = lazy(() => import("@/page/notfound"));

const routes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/tpls",
    component: <Tpls />,
  },
  {
    path: "/editor",
    component: <Editor />,
  },
  {
    path: "/bgs",
    component: <Bgs />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/help",
    component: <Help />,
  },
  {
    path: "/interpolation",
    component: <Interpolation />,
  },
  {
    path: "*",
    component: <NotFound />,
  },
];

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <AliveScope>
      <Suspense fallback={"加载中..."}>
        <Routes>
          {routes.map((item) => (
            <Route key={item.path} path={item.path} element={item.component} />
          ))}
        </Routes>
      </Suspense>
    </AliveScope>
  </BrowserRouter>
  // <App />
);
